var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1084 20.4156H30.3813L38.1033 5.88431C38.3168 5.48323 38.3042 5.01145 38.0704 4.62227C37.8366 4.23239 37.4257 4 36.9714 4H18.8053C18.2453 4 17.7539 4.35908 17.5831 4.89456L10.5597 27.0267C10.4365 27.4152 10.5065 27.8436 10.7473 28.1719C10.988 28.5002 11.3744 28.6969 11.7825 28.6969H20.9548L17.5747 44.4447C17.4494 45.0242 17.721 45.5926 18.2502 45.8593C18.4385 45.9538 18.638 46 18.834 46C19.1909 46 19.5374 45.8488 19.7894 45.5618L40.0702 22.5456C40.4076 22.1627 40.4874 21.6349 40.2774 21.1701C40.0674 20.7047 39.6194 20.4156 39.1084 20.4156ZM19.0369 44.2963L22.3527 28.8481C22.4346 28.468 22.3408 28.076 22.0965 27.7729C21.8515 27.4698 21.4882 27.2962 21.099 27.2962H11.9421L18.8913 5.39993H36.7755L29.0534 19.9312C28.84 20.3323 28.8526 20.8041 29.0863 21.1932C29.3201 21.5831 29.731 21.8155 30.1853 21.8155H38.8481L19.0369 44.2963Z",
    fill: "#8800EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.f9b7f902a9bf2dcac1275dc8460cced1.svg";
export { ForwardRef as ReactComponent };